import { toast } from "react-toastify";
import { Col, Modal, Row, Tooltip } from "antd";
import dayjs from "dayjs";
import { FaDownload } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { PiFilesFill } from "react-icons/pi";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { DeleteBackedupData, MonthDropdown } from "../Services/ApiServices";
import { CatchMessage, HandleDeviceId, HandleMeterId } from "../Shared/Methods";
import classes from "./Modal.module.css";
import Loader from "../SharedComponents/Loader/Loader";
import { CommonDatePicker } from "../Components/CommonForms/CommonDatePicker";
import Commonselectfield from "../Components/CommonForms/CommonSelectField";
import CommonNodataFound from "../Components/CommonNodataFound";
import DeleteConfirmation from "./DeleteConfirmation";

const validationSchema = Yup.object().shape({
  year: Yup.string().required("Yeas is required"),
});

export default function BackedUpDataModal({
  reportId,
  onCancel,
  open,
  headerName,
}: any) {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const { loading } = useSelector((state: any) => state.Dashboard);
  const renderondeviceID = HandleDeviceId();
  const renderonmeterID = HandleMeterId();
  const [MonthList, setMonthList] = useState<any>([]);
  const [deleteModal, setdeleteModal] = useState({
    show: false,
    id: 0,
  });
  const { values, setFieldValue, setValues, errors, touched } = useFormik({
    initialValues: {
      year: dayjs(new Date()).format("YYYY"),
      id: null,
    },
    validationSchema,
    onSubmit: () => {},
  });

  const handleDelete = () => {
    let formData: any = new FormData();
    formData.append("token", LoginData?.token);
    formData.append("reportId", deleteModal?.id);
    DeleteBackedupData(formData)
      .then((res) => {
        if (res.data.status === 1) {
          toast.success(res.data.msg);
          setdeleteModal({ show: false, id: 0 });
          getListMonthIds(values.year);
          setValues((pre) => ({ ...pre, id: null }));
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => {
        CatchMessage(err);
      });
  };

  const getListMonthIds = (year: string) => {
    let formData: any = new FormData();
    formData.append("token", LoginData?.token);
    formData.append("year", year);
    formData.append("device_id", renderondeviceID?.deviceId);
    if (reportId !== 6) {
      formData.append("meter_id", renderonmeterID?.meter_id);
    }
    formData.append("reportId", reportId);
    MonthDropdown(formData)
      .then((res) => {
        if (res?.data?.status === 1) {
          setMonthList(
            res?.data?.data.map((ele: any) => ({
              ...ele,
              label: ele.monthName,
              value: ele?.id,
            }))
          );
        } else {
          setMonthList([]);
        }
      })
      .catch((err) => CatchMessage(err));
  };

  useEffect(() => {
    if (
      LoginData !== null &&
      renderondeviceID?.deviceId &&
      renderonmeterID?.meter_id
    ) {
      getListMonthIds(values.year);
    }
  }, [LoginData, renderondeviceID?.deviceId, renderonmeterID?.meter_id]);

  return (
    <>
      {deleteModal.show && (
        <DeleteConfirmation
          handleSuccess={() => handleDelete()}
          onCancel={() => setdeleteModal({ show: false, id: 0 })}
          open={deleteModal.show}
          closable={!deleteModal.show}
          itemName={"Report"}
        />
      )}
      <Loader isLoader={loading} />
      <Modal open={open} width={700} footer={null} onCancel={onCancel}>
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading}>{headerName}</h4>
          <Row gutter={[16, 16]}>
            <Col sm={12} xs={12}>
              <CommonDatePicker
                value={values.year}
                allowClear={false}
                required={true}
                formate="YYYY"
                onChange={(value) => {
                  setValues((pre) => ({
                    ...pre,
                    year: dayjs(value).format("YYYY"),
                    id: null,
                  }));
                  getListMonthIds(dayjs(value).format("YYYY"));
                }}
                style={{
                  marginRight: "10px",
                  height: "40px",
                }}
                labelname="Year"
                name="year"
                FromDate={values.year}
                ToDate={new Date()}
                picker={"year"}
                DateType={"future"}
              />
            </Col>
            <Col sm={12} xs={12}>
              <Commonselectfield
                labelname="Month"
                value={values.id}
                onChange={(value) => {
                  setFieldValue("id", value);
                }}
                style={{ width: "100%" }}
                options={MonthList}
                size="large"
              />
            </Col>
          </Row>
          <div className="mt-3">
            <h6 className={classes.modal_heading}>{"Backed Up Datas"}</h6>

            <Row className={`${classes.filescontainer} mt-3`} gutter={[16, 16]}>
              {(values.id
                ? MonthList?.filter((ele: any) => ele.id === values.id)
                : MonthList
              ).length > 0 ? (
                (values.id
                  ? MonthList?.filter((ele: any) => ele.id === values.id)
                  : MonthList
                ).map((monthdata: any, index: number) => {
                  return (
                    <Col sm={12} xs={12}>
                      <div className={classes.backup_card}>
                        <div className={classes.slideanimation}></div>
                        <div className={classes.datacardHeader}>
                          <PiFilesFill className={classes.fileiconImg} />
                          <Tooltip title={monthdata.filePath.split("/").pop()}>
                            <h5>{monthdata.filePath.split("/").pop()}</h5>
                          </Tooltip>
                        </div>

                        <div className={classes.backup_buttons}>
                          <Tooltip title={"Download"}>
                            <button
                              type="button"
                              onClick={() => window.open(monthdata?.filePath)}
                              //   style={{ background: "#d8e6ff" }}
                            >
                              <FaDownload style={{ color: "#325ca7" }} />
                            </button>
                          </Tooltip>
                          <Tooltip title={"Delete"}>
                            <button
                              type="button"
                              onClick={() => {
                                setdeleteModal({
                                  show: true,
                                  id: monthdata.id,
                                });
                              }}
                              //   style={{ background: "#ffe2d8" }}
                            >
                              <FaTrashAlt style={{ color: "#f60000" }} />
                            </button>
                          </Tooltip>
                        </div>
                      </div>
                    </Col>
                  );
                })
              ) : (
                <CommonNodataFound messege={"No Files Found"} />
              )}
            </Row>
          </div>
        </div>
      </Modal>
    </>
  );
}
